<div class="title">
    <span>{{ 'translation:Warning' | i18next }}</span>
</div>
<div class="dialog-content">
    <div *ngIf="!isDiallerCheck" class="text-container">
        {{ 'translation:Warning dialog queue one' | i18next}} ({{filteredItems}}), {{ 'translation:Warning dialog queue two' | i18next}}
    </div>
    <div *ngIf="isDiallerCheck" class="text-container">
        {{ 'translation:Warning dialog dialler one' | i18next}} ({{filteredItems}}). {{ 'translation:Warning dialog dialler two' | i18next}}
    </div>
</div>
<mat-dialog-actions>
    <button matButton color="accent" class="ok-button" (click)="closeDialog()">Ok</button>
</mat-dialog-actions>